import { PutObjectCommand } from '@aws-sdk/client-s3';
import getS3Client from '../Generator/getS3Client';

const uploadFileToS3 = async ({ file, uploadPath = '' }) => {
  const s3Client = getS3Client();
  const awsCredentials = localStorage.getItem('aws_credentials');
  // Parse aws-credentials
  // No need to check expiry because handled in refresh token
  const credentials = JSON.parse(awsCredentials);

  const uniqueFileName = `${Date.now()}_${file.name}`;
  const key = `${uploadPath}/${uniqueFileName}`;

  const putCommand = new PutObjectCommand({
    Bucket: credentials.bucket,
    Body: file,
    Key: key,
    ContentType: file.type,
    ContentDisposition: `inline; filename="${encodeURIComponent(file.name)}"`,
  });

  await s3Client.send(putCommand);

  return `${process.env.REACT_APP_STORAGE_URL}/${key}`;
};

export default uploadFileToS3;
